module.exports = __webpack_public_path__ + "img/Hide Icon - charcoal.7d15ff22.svg";